/** The YYYY-MM-DD calendar day an instant falls on in `timeZone`. */
export function toCalendarDayKey(value, timeZone) {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat("en-US", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
      .formatToParts(value)
      .map(({ type, value: part }) => [type, part])
  );
  return `${parts.year}-${parts.month}-${parts.day}`;
}

/** Whole calendar days from `now` to `value` in `timeZone` (negative when past). */
export function calendarDaysBetween(now, value, timeZone) {
  // Parse local calendar keys as UTC solely to count days, independent of DST.
  return (
    (Date.parse(toCalendarDayKey(value, timeZone)) - Date.parse(toCalendarDayKey(now, timeZone))) /
    (24 * 60 * 60 * 1000)
  );
}

/** Format a deadline and compare calendar days in the viewer's timezone. */
export function getDueDateState(value, timeZone, now = new Date()) {
  if (!value) return null;
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return null;

  const daysUntilDue = calendarDaysBetween(now, date, timeZone);
  const format = (options) =>
    new Intl.DateTimeFormat(undefined, { timeZone, ...options }).format(date);

  return {
    iso: date.toISOString(),
    label: format({ month: "short", day: "numeric" }),
    // For lists that reach back past a year boundary, like the overdue report.
    labelWithYear: format({ month: "short", day: "numeric", year: "numeric" }),
    overdue: daysUntilDue < 0,
    daysOverdue: Math.max(0, -daysUntilDue),
    soon: daysUntilDue >= 0 && daysUntilDue <= 2,
  };
}
